import { getNotifications } from '@webapps/business';
import PropTypes from 'prop-types';
import { createContext, useContext, useEffect, useState } from 'react';

import { useAuth } from './AuthProvider';
import { useQuery } from './QueryProvider';

const NotifContext = createContext();

export const NotifProvider = ({ children }) => {
    const [isInitiallyFetched, setIsInitiallyFetched] = useState(false);
    const [total, setTotal] = useState([]);
    const { idUser, profile } = useAuth();

    const { data: { content: notifs = [], totalElements } = {}, refetch } =
        useQuery(getNotifications, {
            key: ['notifsStudent', idUser],
            variables: {
                id: idUser,
                page: 0,
                size: 10000,
                status: 'unread',
            },
            keepPreviousData: true,
            staleTime: 5000,
        });

    return (
        <NotifContext.Provider
            value={{
                totalNotif: totalElements,
                refetch,
            }}
        >
            {children}
        </NotifContext.Provider>
    );
};

NotifProvider.propTypes = {
    children: PropTypes.node,
};

export const useNotif = () => {
    const { refetch, totalNotif } = useContext(NotifContext);
    return {
        totalNotif,
        refetch,
    };
};

export default NotifProvider;